import { useNavigate } from "react-router-dom";
import { SentEInvoicesPage as SentEInvoicesPageView } from "@/components/SentEInvoices";
import { useModules } from "@/auth/ModulesContext";
import { useEInvoicingRegistered } from "@/hooks/useEInvoicingRegistered";

export function SentEInvoicesPage() {
  const navigate = useNavigate();
  const { hasModule, modules } = useModules();
  const registered = useEInvoicingRegistered(modules !== null && hasModule("ar.e_invoicing"));

  // The component is router-agnostic; this wrapper supplies navigation.
  return (
    <SentEInvoicesPageView
      onInvoiceClick={(invoiceId) => navigate(`/invoices/${invoiceId}`)}
      onCreditNoteClick={(creditNoteId) => navigate(`/credit-notes/${creditNoteId}`)}
      registered={registered}
    />
  );
}
